import {Intent} from "@blueprintjs/core";
import log from "loglevel";
import {Tenant} from "./TenantService";
import {getLegacyUserGuid} from "./TenantService";
import {AppToaster} from "../utils/toasters/toaster";
import {Pref} from "../generated/graphql";
import {extractSimplePref} from "../providers/PreferenceProvider";
import {TenantPreferences} from "../constants/constants";
import {OrderEntryType} from "../components/settings/enums/OrderEntry";

const CURRENT = "orderscreen.cshtml";
const LEGACY = "orderscreen.asp";

let cachedTokens: {[key: string]: string} = {};

const navigateToCmsOrder = async (
  tenant: Tenant,
  token: string,
  orderId: string | number | undefined,
  tenantPrefs: Pref[] = [] as Pref[]
): Promise<void> => {
  const orderEntryTypePref = extractSimplePref(tenantPrefs, TenantPreferences.orderEntryType, OrderEntryType.Current);
  let userGuid;

  if (cachedTokens[token]) {
    userGuid = cachedTokens[token];
  } else {
    try {
      userGuid = (await getLegacyUserGuid(token)).data;
      cachedTokens = {};
      cachedTokens[token] = userGuid;
    } catch (error) {
      AppToaster.show({
        intent: Intent.WARNING,
        icon: "warning-sign",
        message: `Failed to get user from CMS: ${error}`
      });
      log.error("Error getting legacy user id.", error);
    }
  }

  window.open(
    `${tenant?.legacyCmsUrl}/${tenant?.shortName}/software/orderentryx/${
      OrderEntryType.Legacy === orderEntryTypePref.value ? LEGACY : CURRENT
    }?UserGUID=${userGuid}` + `${orderId ? `&OrderID=${orderId}` : ""}`
  );
};

export {navigateToCmsOrder};
